<template>
    <div class="menu">
        <div class="block" v-for="(item, index) in menu.children" :key="index" :class="{ show: item.show }"
            @click="item.show = !item.show">
            <div class="tit">
                {{ item.meta.name }}
                <i class="el-icon-d-arrow-right"></i>
            </div>
            <ul>
                <li v-for="(ite, idx) in item.children" v-if="!ite.hidden" :key="idx"
                    :class="menuActive == index + '-' + idx ? 'active' : ''"
                    @click.stop="menuItem(item, ite, index, idx)">
                    {{ ite.meta.name }}
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            menu: []
        };
    },
    computed: {
        // 根据当前路由自动计算选中的菜单项 key（index-idx）
        menuActive() {
            const path = this.$route.path
            const blocks = (this.menu && this.menu.children) || []
            for (let i = 0; i < blocks.length; i++) {
                const item = blocks[i]
                const children = (item && item.children) || []
                for (let j = 0; j < children.length; j++) {
                    const ite = children[j]
                    const full = '/personalCenter/' + item.path + '/' + ite.path
                    if (path === full || path.indexOf(full + '/') === 0) {
                        return i + '-' + j
                    }
                }
            }
            return ''
        }
    },
    watch: {
        // 路由变化后，仅展开选中项所在分组，其余全部折叠
        menuActive(val) {
            if (!this.menu.children) return
            const activeIdx = val ? Number(val.split('-')[0]) : -1
            this.menu.children.forEach((item, idx) => {
                this.$set(item, 'show', idx !== activeIdx)
            })
        }
    },
    mounted() {
        let menu = JSON.parse(JSON.stringify(this.$router.options.routes[2]));
        menu.children.forEach(item => item.show = true);
        this.menu = menu

        const tzz = this.menu.children.find(c => c.path === 'tzz_bf')
        tzz.children.forEach(ite => {
            if (ite.path === 'RepresentativeApply' || ite.path === 'ManagerApply') {
                // 投放站帮扶中心(tzz_bf)下两个菜单需按人员身份显隐，默认先隐藏，待接口确认后放开
                this.$set(ite, 'hidden', true)
            }
        })

        // console.log('tzz:', JSON.parse(JSON.stringify(tzz)));

        // 拉取人员身份，决定「实战超市方案」「发布众筹招股」是否展示
        this.loadPersonIdentity()

    },
    methods: {
        async loadPersonIdentity() {
            const userId = this.vuex_userInfo && this.vuex_userInfo.userId
            if (userId === undefined || userId === null || userId === '') return
            try {
                const res = await this.$http.get('/stage-api/assist/person/identity', {
                    params: { userId: Number(userId) }
                })

                const tzz = this.menu.children.find(c => c.path === 'tzz_bf')
                if (!tzz || !tzz.children) return
                tzz.children.forEach(ite => {
                    if (ite.path === 'RepresentativeApply') this.$set(ite, 'hidden', !res.data.hasRepresentative)
                    if (ite.path === 'ManagerApply') this.$set(ite, 'hidden', !res.data.hasManager)
                })

            } catch (e) {
                console.error('获取人员身份失败，隐藏条件菜单', e)
            }
        },
        menuItem(item, ite, index, idx) {
            this.$router.push('/personalCenter/' + item.path + '/' + ite.path)
            window.scrollTo({ top: 0, behavior: "smooth" });
            // scrollTo(100,0)
        }
    }
};
</script>

<style lang="scss">
.menu {
    .block {
        &.show {
            height: 61px;
            overflow: hidden;
        }

        .tit {
            height: 60px;
            line-height: 60px;
            background-color: #2899df;
            color: #ffffff;
            text-align: center;
            font-size: 20px;
            white-space: nowrap;
            border-bottom: 1px solid #F1F1F1;
            cursor: pointer;
            position: relative;
            padding-right: 40px;
            padding-left: 10px;

            &:hover {
                background-color: #347CAF;
            }

            i {
                position: absolute;
                right: 10px;
                top: 50%;
                transform: translateY(-50%) rotate(90deg);
                transition: transform 0.3s ease;
            }
        }

        // 展开（未折叠）时箭头旋转 180 度
        &:not(.show) .tit i {
            transform: translateY(-50%) rotate(270deg);
        }

        ul {
            list-style: none;
            text-align: center;
            padding-left: 0;
            margin: 0;
            background-color: #f1f1f1;

            li {
                border-bottom: 1px solid rgba(0, 0, 0, 0.1);
                padding: 10px 0;
                white-space: nowrap;
                cursor: pointer;

                &:hover {
                    background: #43b5e7;
                    color: #f60;
                }

                &.active {
                    background: #43b5e7;
                    color: #fff;
                }
            }
        }
    }
}

/* ===== 移动端适配（屏幕小于 1200px 即生效） ===== */
@media (max-width: 1200px) {
    .menu {
        .block {
            /* 折叠态高度随标题高度调整 */
            &.show {
                height: 45px;
            }

            .tit {
                height: 44px;
                line-height: 44px;
                font-size: 15px;
                text-align: left;
                padding-left: 12px;
                padding-right: 34px;

                i {
                    right: 12px;
                }
            }

            /* 子菜单保持竖排：一行一项 */
            ul {
                li {
                    padding: 11px 12px;
                    font-size: 14px;
                    text-align: left;
                }
            }
        }
    }
}
</style>